import angular from 'angular'
import moment from 'moment-timezone'
import './winners.service'

angular
  .module('admin.winners', ['admin.winners.service'])
  .controller('WinnersAdminCtrl', WinnersAdminCtrl)

/** @ngInject */
function WinnersAdminCtrl($scope, $http, WinnersService, API) {
  var vm = this
  vm.items = []
  vm.channels = []
  vm.collectibles = []

  // Date Picker state
  vm.date1 = ''
  vm.date2 = ''

  vm.openCalendarStart = function (e) {
    e.preventDefault()
    e.stopPropagation()
    vm.isOpenStart = true
  }

  vm.openCalendarEnd = function (e) {
    e.preventDefault()
    e.stopPropagation()
    vm.isOpenEnd = true
  }

  // Filter Models
  vm.filters = {
    channels: [],
    userId: '',
    qId: '',
    status: 'all',
  }

  // Pre-load channels and collectibles
  WinnersService.getChannels().then(function (channels) {
    vm.channels = channels
  })

  WinnersService.getCollectibles().then(function (collectibles) {
    vm.collectibles = collectibles
  })

  // User AJAX select2 — GET /users/get/prefix?username=st&start=0&limit=20
  // Uses $http transport so AngularJS AuthorizationInterceptor applies automatically
  $scope.$on('$viewContentLoaded', function () {
    $('#winnersUserFilter').select2({
      placeholder: 'Select User',
      allowClear: true,
      minimumInputLength: 1,
      quietMillis: 300,
      ajax: {
        transport: function (params) {
          $http.get(API.API_URL + 'users/get/prefix', {
            params: { username: params.data.username, start: 0, limit: 20 },
          }).then(function (response) {
            var list = response.data.results || response.data
            params.success({
              results: list.map(function (u) {
                return { id: u.id, text: u.username + (u.email ? ' (' + u.email + ')' : '') }
              }),
            })
          }, params.error)
        },
        data: function (term) {
          return { username: term }
        },
        results: function (data) {
          return data
        },
      },
    })

    $('#winnersUserFilter').on('change', function (e) {
      $scope.$apply(function () {
        vm.filters.userId = e.val || ''
      })
    })
  })

  vm.statusOptions = [
    { id: 'all', name: 'All Statuses' },
    { id: 0, name: 'Active' },
    { id: 1, name: 'Removed' },
  ]

  // Remove modal state
  vm.selectedWinner = null
  vm.removalReason = ''
  vm.removing = false

  // Pagination config
  vm.perPage = 25
  vm.loading = false

  function reloadPagination() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.pagination = { current: 1 }
  }

  reloadPagination()

  vm.resetFilters = function () {
    vm.date1 = ''
    vm.date2 = ''
    vm.filters.channels = []
    vm.filters.userId = ''
    vm.filters.qId = ''
    vm.filters.status = 'all'
    $('#winnersUserFilter').select2('val', '')
    vm.reload()
  }

  vm.reload = function () {
    reloadPagination()
    vm.load(1)
  }

  vm.load = function (pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }

    if (!vm.first) {
      vm.currentPage = pageNumber * vm.perPage
      vm.oldPage = vm.currentPage - vm.perPage
    } else {
      vm.first = false
    }

    var payloadFilters = {
      startDate: vm.date1 ? moment(vm.date1).format('YYYY-MM-DD') : null,
      endDate: vm.date2 ? moment(vm.date2).format('YYYY-MM-DD') : null,
      channels: vm.filters.channels,
      userId: vm.filters.userId,
      qId: vm.filters.qId,
      status: vm.filters.status,
    }

    if (payloadFilters.startDate && payloadFilters.endDate && payloadFilters.startDate > payloadFilters.endDate) {
      swal('Invalid Date Range', 'End Date cannot be before Start Date.', 'warning')
      return
    }

    vm.loading = true
    vm.items = []

    WinnersService.list(vm.oldPage, vm.perPage, payloadFilters)
      .then(function (result) {
        vm.loading = false
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }
        vm.items = result.results
        $('html, body').scrollTop(0)
      })
      .catch(function () {
        vm.loading = false
        swal('Error', 'Failed to fetch winners.', 'error')
      })
  }

  vm.pageChanged = function (newPage) {
    vm.load(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.getChannelName = function (item) {
    return (item.q && item.q.s && item.q.s.ch && item.q.s.ch.t) || '-'
  }

  // Status badge helpers — st: 1 = Removed, 0 = Active
  vm.getStatusLabel = function (st) {
    if (st === 1) return 'Removed'
    return 'Active'
  }

  vm.getBadgeClass = function (st) {
    if (st === 1) return 'label-danger'
    return 'label-success'
  }

  // Remove winner modal
  vm.openRemoveModal = function (winner) {
    vm.selectedWinner = winner
    vm.removalReason = ''
    $('#removeWinnerModal').modal('show')
  }

  vm.confirmRemove = function () {
    if (!vm.selectedWinner) return

    vm.removing = true

    WinnersService.removeWinner(vm.selectedWinner.id, vm.removalReason || '')
      .then(function () {
        vm.removing = false
        $('#removeWinnerModal').modal('hide')
        vm.selectedWinner = null
        vm.removalReason = ''
        toastr.success('Winner removed successfully.')
        vm.reload()
      })
      .catch(function () {
        vm.removing = false
        toastr.error('Failed to remove winner. Please try again.')
      })
  }

  vm.load(1)
}
